import * as React from 'react';
import {action, observable} from 'mobx';
import {LocalStorageHelper} from '../../helpers/localstoragehelper';
import {BatchOpenPortalDialog} from './batch-open-portal-dialog';
import { ModalDialogCommander } from '../../components/modal-dialog-commander';
import { ClientFlowHelper } from '../helpers/client-flow-helper';
import { BatchBeforeAllocationDialog } from './batch-before-allocation-dialog';
import { Models } from '../check-deposit-generated';

export class BatchDialogStore {
	@observable hideOpenPortalMessage: boolean;
	@observable hideBeforeAllocationMessage: boolean;
	/**
	 * The campus key selected for opening the check scanning portal (not per batch line item).
	 * Set via campus selector in dialogs if org is campus aware.
	 */
	@observable selectedCampusKeyForCheckScanningPortal: string | null = null;
	private readonly HideOpenPortalMessageKey = 'CheckDepositBatches_HideOpenPortalMessage';
	private readonly HideBeforeAllocationMessageKey = 'CheckDepositBatches_HideBeforeAllocationMessage';

	constructor(public isCheckScanningReadOnly: boolean, public checkScanningPortalAccess: Models.CheckScanningPortalAccessInfo[] | null, public helpCenterUrl?: string) {
		this.hideOpenPortalMessage = this.getInitialMessageKeyValue(this.HideOpenPortalMessageKey);
		this.hideBeforeAllocationMessage = this.getInitialMessageKeyValue(this.HideBeforeAllocationMessageKey);
		if (this.checkScanningPortalAccess && this.checkScanningPortalAccess.length > 0) {
			this.selectedCampusKeyForCheckScanningPortal = this.checkScanningPortalAccess[0].CampusKey;
		}
	}

	@action
	setSelectedCampusKeyForCheckScanningPortal = (campusKey: string) => {
		this.selectedCampusKeyForCheckScanningPortal = campusKey;
	}

	@action
	toggleHideOpenPortalMessage = (hideMessage: boolean) => {
		if (hideMessage) {
			this.hideOpenPortalMessage = true;
			LocalStorageHelper.getLocalStorage().setItem(this.HideOpenPortalMessageKey, 'true');
		} else {
			this.hideOpenPortalMessage = false;
			LocalStorageHelper.getLocalStorage().removeItem(this.HideOpenPortalMessageKey);
		}
	}

	@action toggleHideBeforeAllocationMessage = (hideMessage: boolean) => {
		if (hideMessage) {
			this.hideBeforeAllocationMessage = true;
			LocalStorageHelper.getLocalStorage().setItem(this.HideBeforeAllocationMessageKey, 'true');
		} else {
			this.hideBeforeAllocationMessage = false;
			LocalStorageHelper.getLocalStorage().removeItem(this.HideBeforeAllocationMessageKey);
		}
	}

	@action
	openDialogOrCheckScanningPortal = () => {
		if(this.hideOpenPortalMessage && (!this.checkScanningPortalAccess || this.checkScanningPortalAccess.length <= 1)) {
			ClientFlowHelper.openCheckScanningPortalWindow(this.selectedCampusKeyForCheckScanningPortal);
			this.openBeforeAllocationDialog();
		} else {
			ModalDialogCommander.showReactDialog(<BatchOpenPortalDialog store={this} />);
		}
	}

	openBeforeAllocationDialog = () => {
		if(this.hideBeforeAllocationMessage && (!this.checkScanningPortalAccess || this.checkScanningPortalAccess.length <= 1)) {
			ModalDialogCommander.forceCloseCurrent();
		} else {
			ModalDialogCommander.showReactDialog(<BatchBeforeAllocationDialog store={this}/>);
		}
	}

	private getInitialMessageKeyValue = (messageKey: string) => {
		const messageKeyStored = LocalStorageHelper.getLocalStorage().getItem(messageKey);
		return messageKeyStored && messageKeyStored === 'true';
	}
}
